import { getBaseUrl, request } from 'src/helper/api';

/**
 * Retrieved the vendor's onboarding details based on signed url.
 * @param {string} [companyName] - The vendor's company name from signed url.
 * @param {string} [expires] - The expiry length of the signed url.
 * @param {string} [data] - The vendor's onboarding id from the signed url.
 * @param {string} [token] - The vendor's token from the signed url.
 * @param {string} [signature] - Unique encrypted value from signed url.
 * @returns {Promise<AxiosResponse<OnboardingDataAPIType>>} - A promise that
 *  resolves to the response of the request.
 */
export const getOnboardingInvite = (
  companyName?: string,
  expires?: string,
  data?: string,
  token?: string,
  signature?: string,
) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/public/vendor-onboarding/invite?company_name=${companyName}&data=${data}&expires=${expires}&token=${token}&signature=${signature}`,
      contentType: 'json',
    },
    'vendor/onboarding/getOnboardingInvite',
  );

export const getOnboardingDetails = (onboardingId?: string, token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/vendor-onboarding/onboarding-details?data=${onboardingId}`,
      contentType: 'json',
      token,
      signal,
    },
    'vendor/onboarding/getOnboardingDetails',
  );

export const getOnboardingStatus = (token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'GET',
      url: `${getBaseUrl()}api/vendor-onboarding/status`,
      contentType: 'json',
      token,
      signal,
    },
    'vendor/onboarding/getOnboardingStatus',
  );

export const setOnboardingStatus = (token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/vendor-onboarding/set-status`,
      contentType: 'json',
      token,
      signal,
    },
    'vendor/onboarding/setOnboardingStatus',
  );

export const markWelcomeBannerSeen = (token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/vendor-onboarding/welcome-banner-seen`,
      contentType: 'json',
      token,
      signal,
    },
    'vendor/onboarding/markWelcomeBannerSeen',
  );

export const setBasicInfo = (token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/vendor-onboarding/set-basic-info`,
      contentType: 'json',
      token,
      signal,
    },
    'vendor/onboarding/setBasicInfo',
  );

export const setPassword = (token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/vendor-onboarding/set-password`,
      contentType: 'json',
      token,
      signal,
    },
    'vendor/onboarding/setPassword',
  );

export const setServices = (token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/vendor-onboarding/set-services`,
      contentType: 'json',
      token,
      signal,
    },
    'vendor/onboarding/setServices',
  );
export const searchAddress = (token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/search-address`,
      contentType: 'json',
      token,
      signal,
    },
    'vendor/onboarding/searchAddress',
  );

export const setServiceArea = (token?: string, signal?: AbortSignal) =>
  request(
    {
      method: 'POST',
      url: `${getBaseUrl()}api/vendor-onboarding/set-service-areas`,
      contentType: 'json',
      token,
      signal,
    },
    'vendor/onboarding/setServiceArea',
  );

export default getOnboardingDetails;
